import { GetInvestorNomineeBankData, InvestorData } from "../../components/JointHolder/CreateJointHolder";
import { ManualJointHolder } from "../../components/JointHolder/jointHolFreeTextpopup/FreeTextPopup";

import { CALL_API } from "../middleware";
import { ApplicationProps, Bank, NomineeType } from "../types/api-types";

import {
  GET_INDIVIDUAL_APPLICATION,
  GET_INDIVIDUAL_APPLICATION_SUCCESS,
  GET_JOINT_HOLDER,
  GET_JOINT_HOLDER_SUCCESS,
  GET_NOMINEE_LIST,
  GET_NOMINEE_LIST_SUCCESS,
  SAVE_APPLICATION,
  SAVE_APPLICATION_SUCCESS,
  SaveApplicationRequestBody,
  SaveApplicationResponseBody
} from "../types/jointHolder";

interface initialValuesJointHolder {
  noOfJointHolders: number;
  primaryHolderId: number;
  secondHolderId: number;
  thirdHolderId: number;
  isBSEEnabled: boolean | null;
  nomineesSOA: boolean |string | null;
  nominees: NomineeType[];
  banks: Bank[];
  manualJointHolders?: ManualJointHolder[];
  applicationId?: string | number;
  documents: { documentId: string; documentType: string; documentName: string }[];
}

export const getIndividualApplication =
  (payload: string) =>
    async (dispatch: any): Promise<InvestorData[]> => {
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/applications/get-individual-applicants?search=${payload}`,
          method: 'GET',
          types: [GET_INDIVIDUAL_APPLICATION_SUCCESS, GET_INDIVIDUAL_APPLICATION],
        },
      });
    };

export const getNomineeBankList =
  (body: GetInvestorNomineeBankData) =>
    async (dispatch: any): Promise<ApplicationProps[]> => {
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/applications/applicants-details`,
          method: 'POST',
          types: [GET_NOMINEE_LIST_SUCCESS, GET_NOMINEE_LIST],
          body: body,
        },
      });
    };

export const createJointHolderApplication =
  (body: initialValuesJointHolder) =>
    async (dispatch: any): Promise<initialValuesJointHolder> => {
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/applications/create-account`,
          method: 'POST',
          types: [GET_JOINT_HOLDER_SUCCESS, GET_JOINT_HOLDER],
          body: body,
        },
      });
    };

export const saveApplication =
  (body: SaveApplicationRequestBody) =>
    async (dispatch: any): Promise<SaveApplicationResponseBody> => {
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/applications/create-jointholder-manual`,
          method: 'POST',
          types: [SAVE_APPLICATION_SUCCESS, SAVE_APPLICATION],
          body: body,
        },
      });
    };
    

